import { useEffect, useState } from "react"
import algoliasearch from "algoliasearch/lite"

const environmentFromHost = host => {
  const isProduction = host.indexOf("zendesk.com") > 0
  const env = isProduction ? "production" : "staging"
  const publicKey = isProduction
    ? "6ffabb70ba8555c0ab240fa8d6d6d4e9"
    : "d92c65376fb77e417c67e9aad82bff05"
  return { env, publicKey }
}

// Memoize the Algolia search client. Note that, due to gatsby restrictions,
// we cannot use `window` in any code path that will run during SSR. Instead
// we must replicate the behaviour of `useMemo` by combining `useState`
// and `useEffect`, which will only run client-side.
export default () => {
  const [client, setClient] = useState()
  useEffect(() => {
    const environment = environmentFromHost(window.location.host)

    const appId = "0EX3A19VW2"
    const index = `${environment.env}_DEVELOPER_DOCS`
    const publicSearchKey = environment.publicKey

    setClient(algoliasearch(appId, publicSearchKey).initIndex(index))
  }, [])

  return client
}
